<app-dashboard-widget-card [titleKey]="titleKey">
  @if (hasData) {
  <div class="chart-wrapper">
    <canvas #canvas aria-label="{{ titleKey }}" role="img"></canvas>
  </div>
  } @else {
  <div class="chart-empty">{{ 'pages.dashboard.empty' | translate }}</div>
  }
</app-dashboard-widget-card>
